import * as Yup from 'yup';

const EmployeeSchema = Yup.object({
  userName: Yup.string()
    .trim()
    .required('Please enter a user name')
    .min(2, 'Please enter at least 2 characters')
    .max(60, 'Please enter no more than 60 characters'),
  email: Yup.string().trim().email('Please enter a valid email address').required('Please enter an email'),
  userRoleId: Yup.string().required('Please select a user role'),
});

export default EmployeeSchema;
